import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { Button } from '../components/ui/button';

export const Terms = () => {
  return (
    <div data-testid="terms-page">
      <section className="relative py-24 bg-navy" data-testid="terms-hero">
        <div className="container-custom">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-2 bg-emerald text-white font-semibold text-xs uppercase tracking-wider mb-6">
              Legal
            </span>
            <h1 className="font-manrope font-bold text-4xl sm:text-5xl text-white leading-tight mb-4">
              Terms of Service
            </h1>
            <p className="text-navy-200">Last updated: December 2024</p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="space-y-8 text-navy-700 leading-relaxed">
            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">1. Agreement to Terms</h2>
              <p>
                By accessing or using services provided by HealthCheck Medical Inc. through healthcentermedicalgroup.online, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">2. Services</h2>
              <p>
                HealthCheck Medical Inc. provides comprehensive management services organization (MSO) solutions including revenue cycle management, practice management, credentialing, compliance, HR, and IT services to healthcare providers.
              </p>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">3. Client Responsibilities</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain confidentiality of account credentials</li>
                <li>Comply with all applicable healthcare regulations</li>
                <li>Cooperate with implementation and support requests</li>
              </ul>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">4. Payment Terms</h2>
              <p>
                Fees for services are outlined in individual service agreements. Payment terms, invoicing schedules, and pricing models will be specified in your service contract with HealthCheck Medical Inc.
              </p>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">5. Confidentiality & HIPAA</h2>
              <p>
                Both parties agree to maintain strict confidentiality of all information exchanged. HealthCheck Medical Inc. operates in full compliance with HIPAA regulations and executes Business Associate Agreements with all healthcare clients.
              </p>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">6. Limitation of Liability</h2>
              <p>
                HealthCheck Medical Inc.'s liability shall be limited as specified in individual service agreements. We are not liable for indirect, incidental, or consequential damages arising from service use.
              </p>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">7. Termination</h2>
              <p>
                Either party may terminate services in accordance with the terms specified in the service agreement. Upon termination, we will facilitate a smooth transition and return of client data.
              </p>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">8. Governing Law</h2>
              <p>
                These Terms are governed by the laws of the State of Delaware, without regard to conflict of law principles.
              </p>
            </div>

            <div>
              <h2 className="font-manrope font-bold text-2xl text-navy mb-4">9. Contact Information</h2>
              <div className="bg-navy-50 p-6 space-y-2">
                <p className="font-manrope font-semibold text-navy">HealthCheck Medical Inc.</p>
                <p className="text-sm">Headquarters: 919 N Market St Ste 600, Wilmington, DE 19801</p>
                <p className="text-sm">Main Office: 7100 Commerce Way Ste 182, Brentwood, TN 37027</p>
                <p className="text-sm">Phone: (855) 831-1992</p>
                <p className="text-sm">Email: legal@healthcentermedicalgroup.online</p>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-silver-light">
            <Button 
              asChild
              className="bg-navy hover:bg-navy-700 text-white rounded-none font-semibold tracking-wide uppercase text-xs h-12 px-8"
              data-testid="terms-contact-btn"
            >
              <Link to="/contact">Contact Us</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};
